<script>
    export let conditions; // conditions is an input
    let feedTypes = ["scroll", "swipe"];
    let feedTypeParams = [];
    let inputDefaultValue = "scroll"

    const getStorage = (conditions) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		if (params) {
			if (params.feedTypeParams) {
				feedTypeParams = params["feedTypeParams"];
			}
		} else {
			params = {};
		}
		// if no feed parameters in localStorage yet, create and populate it with default value
		if (!feedTypeParams) {
			feedTypeParams = [];
			for (let i = 0; i < conditions; i++) {
				feedTypeParams.push({
					"feed": inputDefaultValue,
				});
			}
		} else {
			// if feed parameters in localStorage, check if it has the right number of conditions
			if (feedTypeParams.length < conditions) {
				// if not, add the missing conditions
				for (let i = feedTypeParams.length; i < conditions; i++) {
					feedTypeParams.push({
						"feed": inputDefaultValue,
					});
				}
			}
		}
		params["feedTypeParams"] = feedTypeParams;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};

    getStorage();
	$: getStorage(conditions);


	const updateStorage = (parameters) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		params["feedTypeParams"] = parameters;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	$: updateStorage(feedTypeParams);


	const formatForAPI = (conditions, parameters, parameterName) => {
		// console.log(parameters);
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected")
		);

		let formatted = [];
		for (let i = 0; i < conditions; i++) {
			let feedType = parameters[i][parameterName];
			formatted.push({
				condition: i + 1,
				param: parameterName,
				value: feedType,
			});

		}
		if (paramsSelected) {
			paramsSelected[parameterName] = formatted;
		} else {
			paramsSelected = {};
			paramsSelected[parameterName] = formatted;
		}
		localStorage.setItem(
			"createStudyParamsSelected",
			JSON.stringify(paramsSelected)
		);
	};
	$: formatForAPI(conditions, feedTypeParams, "feed");
</script>

<hr />
<h3>Feed Type</h3>

<div>
    <p>
        Scroll will enable continuous scrolling.
        Swipe will enable swipes instead of scrolling, where only one post is displayed per swipe.
    </p>
</div>


{#each { length: conditions } as _, ii}
	<p><strong>Condition {ii + 1}</strong></p>
	<div>
		<label for={"condition-" + (ii + 1) + ";feed"} />
		<select
			name={"condition-" + (ii + 1) + ";feed"}
			bind:value={feedTypeParams[ii]["feed"]}
		>
			{#each feedTypes as feedType}
				<option value={feedType}>{feedType}</option>
			{/each}
		</select>
	</div>
{/each}
